import {
    apiRequest,
    RiwayatNikahDetail,
    RiwayatNikahApprove
} from "../../../../../services/adapters/kepegawaian/riwayatnikahService"

class ApproveRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", RiwayatNikahDetail, {
            params: query
        }, true)
    }

    fetchApprove = async (query) => {
        return await apiRequest("post", RiwayatNikahApprove, {
            body: query
        }, true)
    }
}

export default ApproveRepository